import { render, staticRenderFns } from "./FPotensIKawasanJarakTerdekat.vue?vue&type=template&id=5e6f7914&scoped=true"
import script from "./FPotensIKawasanJarakTerdekat.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanJarakTerdekat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f7914",
  null
  
)

export default component.exports